import styled from 'styled-components';

import { COLORS } from '~/src/common/theme';

export const CardButtonContainer = styled.button`
  z-index: 1;
  position: absolute;
  inset: 8px 8px auto auto;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 24px;
  height: 24px;
  margin: 0;
  padding: 0;

  cursor: pointer;
  font-size: 16px;

  border: none;
  border-radius: 4px;
  color: ${COLORS.ACTION_DEFAULT};
  background: ${COLORS.NEUTRAL_WHITE};
`;

export const FocusButtonContainer = styled.button`
  display: flex;
  width: fit-content;
  align-items: center;

  gap: 8px;
  margin: 0;
  padding: 4px 8px;

  cursor: pointer;
  color: ${COLORS.NEUTRAL_DEFAULT};

  border: none;
  border-radius: 4px;
  background: ${COLORS.GROUND_PROMOLIGHT};

  [role='img'] {
    font-size: 16px;
  }

  label {
    font-size: 12px;
    font-weight: 700;
    line-height: 24px;
  }

  > * {
    pointer-events: none;
  }
`;
